/* Visser webshop: kadoberichtje bij een product. */
(function () {
  'use strict';

  function bindGift(root) {
    (root || document).querySelectorAll('[data-vc-gift]').forEach(function (box) {
      if (box.dataset.vcBound) return;
      box.dataset.vcBound = '1';

      var toggle = box.querySelector('.vc-gift__toggle');
      var panel = box.querySelector('.vc-gift__panel');
      var field = box.querySelector('.vc-gift__input');
      var count = box.querySelector('[data-vc-gift-count]');
      if (!toggle || !panel || !field) return;

      toggle.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        box.classList.toggle('is-open', open);
        if (open) setTimeout(function () { field.focus(); }, 40);
      });

      field.addEventListener('input', function () {
        if (count) count.textContent = String(field.value.length);
      });

      /* Een leeg veld sturen we niet mee, anders komt er een lege notitie
         bij de bestelling te staan. */
      var form = field.closest('form');
      if (form && !form.dataset.vcGiftBound) {
        form.dataset.vcGiftBound = '1';
        form.addEventListener('submit', function () {
          field.disabled = field.value.trim().length === 0;
          setTimeout(function () { field.disabled = false; }, 1200);
        }, true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindGift(document); });
  } else {
    bindGift(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bindGift(e.target); });
})();
